import { memo } from "react";

/**
 * Loading placeholder for the comparison grid, shaped like a few rows of a
 * few columns - mirrors the `CartLineItemSkeleton` convention of raw
 * `animate-pulse bg-gray-200` blocks rather than a generic spinner.
 */
export const SupplierComparisonGridSkeleton = memo(
  function SupplierComparisonGridSkeleton() {
    return (
      <div
        className="animate-pulse overflow-hidden rounded-lg border border-gray-200 bg-white"
        aria-hidden="true"
      >
        <div className="flex gap-3 border-b border-gray-200 p-4">
          <div className="h-4 w-28 rounded bg-gray-200" />
          <div className="h-4 w-24 rounded bg-gray-200" />
          <div className="h-4 w-24 rounded bg-gray-200" />
          <div className="h-4 w-24 rounded bg-gray-200" />
        </div>
        {[0, 1, 2].map((row) => (
          <div
            key={row}
            className="flex items-center gap-3 border-b border-gray-100 p-4"
          >
            <div className="h-8 w-32 rounded bg-gray-200" />
            <div className="h-8 w-24 rounded bg-gray-100" />
            <div className="h-8 w-24 rounded bg-gray-100" />
            <div className="h-8 w-24 rounded bg-gray-100" />
          </div>
        ))}
      </div>
    );
  }
);
